import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = { class: "preview-list el-upload-list el-upload-list--picture-card" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = ["src"]

import { useRouter } from 'vue-router'
import { useStore } from '@/store/index'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { getCurrentInstance, reactive, ref, onActivated } from 'vue'
import { getTrainingListApi, delOrShowTrainingApi, saveTrainingApi, updateTrainingSortApi } from '@/apis/merchant'
import Pagination from '@/components/Pagination.vue'
import Upload from '@/components/upload/Index.vue'
import { getFileSuffix } from '@/utils/index'
import { Plus, Delete } from '@element-plus/icons-vue'

interface RowI { // 每行数据模型
    file_name: string, // 名称
    file_url: string, // 文件地址
    file_sort: number | string, // 排序值
    file_type: number, // 类型
    file_thumb?: string, // 封面图
    previewList?: [], // 预览图
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TrainingList',
  setup(__props) {

const {proxy} = getCurrentInstance() as any
const router = useRouter()
const store = useStore()

const filters = reactive({
    title: '',
    file_type: '',
    page: 1,
    page_size: 10,
})

// 表格数据
const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const {code, data, msg} = await getTrainingListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}

// 搜索
const onSearch = () => {
    filters.page = 1
    getList()
}

// 修改排序
const onSortBlur = async (row) => {
    const { id, file_sort:sort } = row
    const { code, data, msg } = await updateTrainingSortApi(id, sort) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    proxy.$message({ type: 'success', message: '修改成功' })
}

// 上传弹框
const formData = reactive({
    title: '', // 标题
    sub_title: '', // 副标题
    file_thumb: '', // 视频封面图
})
const uploadDialog = ref(false) // 弹框
const uploadList = ref<RowI[]>([]) // 上传列表
const row:RowI = reactive<RowI>({
    file_name: '',
    file_url: '',
    file_sort: '',
    file_type: NaN,
})
// 资料上传前校验
const onBeforeUpload = (file) => {
    if (file.size > 1024 * 1024 * 35) {
        proxy.$message({ type: 'error', message: '视频须小于35M' })
        return false
    }
    store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, true)
}
// 资料上传成功回调
const onUploadSuccess = (res) => {
    store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, false)
    const { code, data, msg } = res
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    const { file_name, url:file_url } = res.data
    const maxFileSort = Math.max( ...tableData.value.map(item => item.file_sort));
    uploadList.value.push({
        file_name,
        file_url,
        file_sort: tableData.value.length > 0 ? maxFileSort + 1 : '',
        file_type: getFileSuffix(file_name) === 'mp4' ? 1 : 2,
        file_thumb: '',
        previewList: []
    })
}
// 删除资料回调
const onUploadDel = (index) => {
    proxy.$confirm('确定要删除当前行吗？', '提示', {
        type: 'warning'
    }).then(() => {
        uploadList.value.splice(index, 1)
    }).catch(() => {
        console.log('取消删除')
    })
}
// 封面上传成功回调
const onThumbUploadSuccess = (res, index) => {
    const { code, data, msg } = res
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    
    const { o_path } = data.img_info
    uploadList.value[index].file_thumb = o_path
    // @ts-ignore
    uploadList.value[index].previewList?.push(o_path)
    store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, false)
}
// 封面移除
const onThumbRemove = (index) => {
    uploadList.value[index].file_thumb = ''
    uploadList.value[index].previewList = []
}
// 保存
const onSave = () => {
    proxy.$refs['uploadForm'].validate((valid:boolean) => {
        if (valid) {
            let trains_info = { ...formData, trains_info: uploadList.value }
            saveTrainingApi(trains_info).then((res:any) => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: '保存成功' })
                onUploadDialogClose()
                getList()
            })
        }
    })
}
// 弹框关闭前清空数据
const onUploadDialogClose = () => {
    formData.title = ''
    formData.sub_title = ''
    formData.file_thumb = ''
    uploadList.value = []
    uploadDialog.value = false
}

// 视频预览
const previewDialog = ref(false) // 预览弹框
const videoTitle = ref('') // 预览弹框标题
const videoSrc = ref('') // 预览弹框视频链接

// 弹框校验规则
const rules = reactive({
    title: [
        { required: true, trigger: 'blur', message: '请填写课程标题' }
    ],
    sub_title: [
        { required: true, trigger: 'blur', message: '请填写课程副标题' }
    ]
})

// 删除
const onDel = (row) => {
    const { id, title } = row
    proxy.$confirm(`确认要删除 ${title} 吗？`, '提示', {
        type: 'warning'
    }).then(() => {
        delOrShowTrainingApi({
            id,
            type: 1
        }).then((res:any) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '删除成功' })
            getList()
        })
    }).catch(() => {
        console.log('')
    })
}

// 预览
const onPreview = (row) => {
    window.open(row.file_url)
}

const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

onActivated(() => {
    getList()
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.title) = $event)),
        placeholder: "课程标题",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.file_type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.file_type) = $event)),
        filterable: "",
        placeholder: "文件类型",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, { value: "" }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("全部")
            ])),
            _: 1
          }),
          _createVNode(_component_el_option, {
            value: 1,
            label: "视频"
          }),
          _createVNode(_component_el_option, {
            value: 2,
            label: "文档"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (uploadDialog.value = true))
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode("上传课程")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "课程标题"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sub_title",
          label: "副标题"
        }),
        _createVNode(_component_el_table_column, { label: "文件类型" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.file_type == 1 ? '视频' : '文档'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "排序" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_input, {
              modelValue: scope.row.file_sort,
              "onUpdate:modelValue": ($event: any) => ((scope.row.file_sort) = $event),
              modelModifiers: { trim: true },
              maxlength: "4",
              onBlur: ($event: any) => (onSortBlur(scope.row))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "创建时间"
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: ($event: any) => (onPreview(scope.row))
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("预览")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                onClick: ($event: any) => (onDel(scope.row))
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("删除")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "上传课程",
      modelValue: uploadDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((uploadDialog).value = $event)),
      "before-close": onUploadDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, { onClick: onUploadDialogClose }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onSave
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: formData,
          class: "form bordered",
          "label-width": "100",
          rules: rules,
          ref: "uploadForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "课程标题",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: formData.title,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.title) = $event)),
                  placeholder: "10字以内",
                  maxlength: "10",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "课程副标题",
              prop: "sub_title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: formData.sub_title,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.sub_title) = $event)),
                  placeholder: "20字以内",
                  maxlength: "20",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "上传资料" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  action: "/api/admin/brands/upload_vedio",
                  "show-file-list": false,
                  "before-upload": onBeforeUpload,
                  "on-success": onUploadSuccess,
                  accept: ".mp4,.pdf"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "no-label" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: uploadList.value,
                  border: "",
                  stripe: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "file_name",
                      label: "文件名称"
                    }),
                    _createVNode(_component_el_table_column, { label: "封面图" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("ul", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.previewList, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              class: "preview-item el-upload-list__item",
                              key: index
                            }, [
                              _createVNode(_component_el_image, {
                                src: item,
                                "preview-src-list": scope.row.previewList,
                                "initial-index": index,
                                "hide-on-click-modal": "",
                                "append-to-body": "",
                                "z-index": 3000
                              }, null, 8, ["src", "preview-src-list", "initial-index"]),
                              _createVNode(_component_el_icon, {
                                class: "icon",
                                onClick: ($event: any) => (onThumbRemove(scope.$index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Delete))
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          }), 128)),
                          _withDirectives(_createVNode(_component_el_upload, {
                            class: "el-upload-list__item empty-item",
                            ref: "uploadRef",
                            accept: "image/png,image/jpg,image/jpeg",
                            action: "/api/cake/setSpecsImg?x-oss-process=style/specs&oss_file=training_file_thumb",
                            "before-upload": onBeforeUpload,
                            "on-success": (res) => onThumbUploadSuccess(res, scope.$index),
                            "list-type": "picture-card",
                            "show-file-list": false
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Plus))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["on-success"]), [
                            [_vShow, scope.row.previewList.length == 0]
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { label: "排序" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          modelValue: scope.row.file_sort,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.file_sort) = $event),
                          modelModifiers: { trim: true },
                          maxlength: "4"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { label: "操作" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "small",
                          onClick: ($event: any) => (onUploadDel(scope.$index))
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode("删除")
                          ])),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: videoTitle.value,
      modelValue: previewDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((previewDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("video", { src: videoSrc.value }, null, 8, _hoisted_6)
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})